export default "__VITE_ASSET__DM40aFz$__"